require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./solutions-烟台青少年宫.json") })
        }
      }, "path---solutions-烟台青少年宫");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---solutions-烟台青少年宫!./.cache/json/solutions-烟台青少年宫.json
// module id = 477
// module chunks = 231608221292675